import { prop } from 'ramda';
import { useCallback } from 'react';
import { useDeviceSelector } from 'js/store/hooks';

export const useDownloadPLC = ({ installerKey, installerVersion, installerBaseURL }) => {
    const os = useDeviceSelector(prop('os'));

    return useCallback(() => {
        let gcOS;

        switch (os) {
            case 'windows':
                gcOS = 'win';
                break;
            case 'macintosh':
                gcOS = 'mac';
                break;
            default:
                return;
        }

        const params = new URLSearchParams({
            id: installerKey,
            os: gcOS,
            version: installerVersion
        });

        const url = new URL(installerBaseURL, location.href);

        url.search = params.toString();

        window.open(url.toString(), '_self');
    }, [os, installerKey, installerVersion, installerBaseURL]);
};
